import React from 'react'

import '../terminal.css';
import '../fonts/Terminal.woff';
import Box from '../Components/box.jsx';
import download from '../Assets/download.svg'
import { useEffect } from 'react';
import YoutubeEmbed from '../Components/youtube.jsx';
import Car from '../Components/carousel.jsx';
import axios from 'axios';
import Dropdown from 'react-dropdown';

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'



const defaultData  = [
  {
    name: 'tanner',
    score: 420,
    date: 'blah',
    country: 'UK',
    time: 123450,
    stage: 420,
    rank: 1
  },
  {
    name: 'tanner2',
    score: 421,
    date: 'blah',
    country: 'UK',
    time: 123450,
    stage: 420,
    rank: 2
  },
]

const columnHelper = createColumnHelper()

const columns = [
  columnHelper.accessor('rank', {
  	header: () => <strong>Rank</strong>,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('name', {
  	header: () => <strong>Name</strong>,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('score', {
    header: () => <strong>Score</strong>,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('time', {
    header: () => <strong>Time</strong>,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('stage', {
    header: () => <strong>Stage</strong>,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('date', {
    header: () => <strong>Date</strong>,
    cell: info => info.renderValue().slice(0,10),
  }),
  columnHelper.accessor('country', {
    header: () => <div/>,
  })
]




const HighScores = ({mainBoxHeight, mainBoxWidth}) => {

	const [data, setData] = React.useState([])


	const getData = async (from, max, level) => {
	    try {
	      const response = await axios.get(`https://killingmachinemovement.com/api/robotron/scores?from=${from}&max=${max}&level=${level}`);
	      const data = response.data;
	      setData(data);
	    } catch(err) {
	      console.error(err);
	    }
	}


	useEffect(() => {
		document.title = 'ROBOTRON - High Scores'
		getData(0,5000,2)
	}, []);

	const textStyle = {color:"#0f0", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:20, letterSpacing:"3px", opacity:0.9, float:"left", textAlign:"left"}

	const rerender = React.useReducer(() => ({}), {})[1]

	const table = useReactTable({
	  data,
	  columns,
	  getCoreRowModel: getCoreRowModel(),
	})

	const levels = [
		{
			value: 2,
			label: "Robo Zone"
		},
		{
			value: 10,
			label: "Mengarite Cleanup"
		},
		{
			value: 15,
			label: "Downtown"
		},
		{
			value: 11,
			label: "Red Square Guy Gauntlet"
		},
		{
			value: 12,
			label: "Resistance Town Hall"
		},
		{
			value: 9,
			label: "Last Hope Of Mankind"
		},
		{
			value: 17,
			label: "Operation 420"
		},
		{
			value: 16,
			label: "Kormacopia"
		},
		{
			value: 18,
			label: "Kormasolidate"
		},
		{
			value: 13,
			label: "Doppelganger"
		},
		{
			value: 19,
			label: "Reactor"
		}
	]

	const [selectedLevel, setSelectedLevel] = React.useState(levels[0])

	const onSelect = async (option) => {
		await getData(0, 5000, option.value)
		setSelectedLevel(option)
	}

	return <Box height={mainBoxHeight-160} width={mainBoxWidth-60} down={100} style={{paddingTop:20}} corner={0}>
		<div style={{...textStyle, overflowY:"scroll", overflowX:"scroll", height:mainBoxHeight-220, width:mainBoxWidth-120}}>
			<h2 style={{textAlign: "center"}}><strong>High Scores</strong></h2>

			<Dropdown className={"dropdown"} onChange={onSelect} options={levels} value={selectedLevel} />

			<div className="p-2 highScores" style={{width:"100%"}}>
		      <table style={{width:"100%"}}>
		        <thead>
		          {table.getHeaderGroups().map(headerGroup => (
		            <tr key={headerGroup.id}>
		              {headerGroup.headers.map(header => (
		                <th key={header.id}>
		                  {header.isPlaceholder
		                    ? null
		                    : flexRender(
		                        header.column.columnDef.header,
		                        header.getContext()
		                      )}
		                </th>
		              ))}
		            </tr>
		          ))}
		        </thead>
		        <tbody>
		          {table.getRowModel().rows.map(row => (
		            <tr key={row.id}>
		              {row.getVisibleCells().map(cell => (
		                <td key={cell.id}>
		                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
		                </td>
		              ))}
		            </tr>
		          ))}
		        </tbody>
		        <tfoot>
		          {table.getFooterGroups().map(footerGroup => (
		            <tr key={footerGroup.id}>
		              {footerGroup.headers.map(header => (
		                <th key={header.id}>
		                  {header.isPlaceholder
		                    ? null
		                    : flexRender(
		                        header.column.columnDef.footer,
		                        header.getContext()
		                      )}
		                </th>
		              ))}
		            </tr>
		          ))}
		        </tfoot>
		      </table>
		      <div className="h-4" />
		    </div>
		</div>
	  </Box>

}


// (
//     name: String,
//     score: Long,
//     date: String,
//     level: Int,
//     country: String,
//     time: Long,
//     stage: Option[Int],
//     submittedScore: Boolean,
//     rank: Long
// )

export default HighScores